
<script>
import request from "./request.vue";
import session from "./session.vue";

export default {


  get: async function() {
    try {
      const resp =  await request.send('https://api.japanparts.com.br/api/banners', {}, false, 'get');
      resp.urlImages = 'https://static.japanparts.com.br';
      return resp;
    } catch (error) {
      console.log(error)
    }
	}
};
</script>



// WEBPACK FOOTER //
// src/api/banner.vue